import { createActions } from 'redux-actions';

export const { companyWebsiteLinkClick } = createActions('COMPANY_WEBSITE_LINK_CLICK');

export const { loadCompanyDetailsJobs, loadedCompanyDetailsJobs, errorCompanyDetailsJobs } = createActions(
  'LOAD_COMPANY_DETAILS_JOBS',
  'LOADED_COMPANY_DETAILS_JOBS',
  'ERROR_COMPANY_DETAILS_JOBS',
);
